import type { ReactNode } from 'react';

import { usePermissions } from '../hooks/use-permissions';

interface RequirePermissionProps {
  children: ReactNode;
  fallback?: ReactNode;
  permission?: string;
  permissions?: string[];
  requireAll?: boolean;
}

export function RequirePermission({
  children,
  fallback = null,
  permission,
  permissions,
  requireAll = false,
}: RequirePermissionProps) {
  const { can, canAny, canAll } = usePermissions();

  let allowed = false;

  if (permission) {
    allowed = can(permission);
  } else if (permissions) {
    allowed = requireAll ? canAll(...permissions) : canAny(...permissions);
  }

  return allowed ? <>{children}</> : <>{fallback}</>;
}
